import CommonOTSheet from "../../components/common/OTSheet/CommonOTSheet"

const AllSheet = () => {
  return (
    <div className="bg-white">
      <CommonOTSheet view_by_status={0} sheet_name="All" />
    </div>
  );
}
export default AllSheet